import React, {
    ChangeEvent,
    useEffect,
    useLayoutEffect,
    useState,
} from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import {
    Avatar,
    Button,
    Paper,
    Stack,
    Tab,
    Tabs,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";

import style from "./Profile.module.scss";
import { useAuthStore } from "../../../store/auth.store";

import { AccountTab } from "./tabs/Account.ProfileTab";
import { LicAccount } from "./tabs/LicAccount.ProfileTab";

const items = [
    { id: "general", label: "Общая информация" },
    { id: "account", label: "Лицевой счет" },
    // { id: "security", label: "Безопасность" },
    // { id: "notifications", label: "Уведомления" },
];

export function Profile() {
    const isMobile = useMediaQuery("(max-width:700px)");
    const [active, setActive] = useState("general");
    

    return (
        <div>
            <h2 style={{
                marginBottom:"30px"
            }}>Профиль</h2>
            <Paper>
                <Box
                    sx={{
                        display: "flex",
                        gap: isMobile ? 0 : 3,
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    {/* левая колонка-меню */}
                    {!isMobile && (
                        <Box sx={{ width: 240 }}>
                            <List sx={{ py: 1 }}>
                                {items.map((it) => (
                                    <ListItem key={it.id} disablePadding>
                                        <ListItemButton
                                            selected={active === it.id}
                                            onClick={() => setActive(it.id)}
                                            sx={{
                                                my: 0.5,
                                                px: 2.5,
                                                py: 2,
                                                height: 48,
                                                borderTopRightRadius: 2,
                                                borderBottomRightRadius: 2,
                                                color: "text.secondary",
                                                "&.Mui-selected": {
                                                    bgcolor: "#daf1ffff",
                                                    color: "text.primary",
                                                    borderLeftWidth: 2,
                                                    borderLeftColor: "#0E74B4",
                                                    borderLeftStyle: "solid",
                                                },
                                            }}
                                        >
                                            <ListItemText
                                                primary={it.label}
                                                primaryTypographyProps={{
                                                    fontSize: 15,
                                                    fontWeight: 400,
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    )}
                    {isMobile && (
                        <Tabs
                            value={active}
                            onChange={(event: any, value: string) =>
                                setActive(value)
                            }
                            sx={{
                                maxWidth: "calc(100vw - 48px)",
                            }}
                            variant="scrollable"
                            scrollButtons={false}
                        >
                            {items.map((n) => {
                                return <Tab label={n.label} value={n.id} />;
                            })}
                        </Tabs>
                    )}
                    {/* правая часть с контентом */}
                    <Box
                        sx={{
                            flex: 1,
                            p: 3,
                            bgcolor: "background.paper",
                            borderRadius: 2,
                        }}
                    >
                        {active === "general" && (
                            <AccountTab/>
                        )}
                        {active === "account" && (
                            <LicAccount/>
                        )}
                        {/* {active === "security" && (
                            <div>Контент «Безопасность»</div>
                        )}
                        {active === "notifications" && (
                            <div>Контент «Уведомления»</div>
                        )} */}
                    </Box>
                </Box>
            </Paper>
        </div>
    );
}
